const QuestionDetails = (state = [], action) => {
    switch (action.type) {
        case 'ATEAM_MailDetails':
            return action.payload
        default:
            return state
    }
}
export default QuestionDetails